module.exports = __webpack_public_path__ + "img/ic_logo_jd@2x.94f68183.png";